// src/App/Animations/HeroAnimation.js
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
import Animation from "./Animation.js";

export default class HeroAnimation extends Animation {
  constructor(element) {
    super(element);
  }

  setInitialState() {
    this.title = this.element.querySelector(".hero__title");
    this.splittedTitle = SplitText.create(this.title);
    this.subtitle = this.element.querySelector(".hero__subtitle");

    gsap.set(this.subtitle, { opacity: 0, yPercent: 100 });
    gsap.set(this.splittedTitle.chars, { opacity: 0, yPercent: 100 });
  }

  createTimeline() {
    const tl = gsap.timeline({ paused: true });

    tl.to(this.subtitle, {
      yPercent: 0,
      opacity: 1,
    })
      .to(
        this.splittedTitle.chars,
        {
          opacity: 1,
          yPercent: 0,
          duration: 0.75,
          stagger: 0.04,
          ease: "back.out(2.25)",
        },
        "<"
      )
      .to(
        this.splittedTitle.chars,
        {
          textShadow: "0px 6px #be26e2, 0px 12px #b200dd, 0px 18px #9100b4",
          stagger: 0.04,
          duration: 1,
          ease: "power3.out",
        },
        "<0.25"
      );

    return tl;
  }
}
